import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  ElementRef,
  inject,
  input,
  InputSignal,
  signal,
  TemplateRef,
  WritableSignal
} from "@angular/core";
import { IconModule } from "@ogs-gmbh/ngx-m3-components";
import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
import { SIDEBAR_ICONS } from "@core/components/ui/sidebar/constants/icon.constant";
import { MatListModule } from "@angular/material/list";
import { IconName } from "@fortawesome/fontawesome-common-types";

@Component({
  selector: "app-core-sidebar-list-item",
  templateUrl: "./sidebar-list-item.component.html",
  styleUrl: "sidebar-list-item.component.scss",
  imports: [
    IconModule,
    MatListModule
  ],
  host: {
    '[class.active]': 'collapsed()'
  },
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class SidebarListItemComponent implements AfterContentInit {
  elementRef: ElementRef = inject(ElementRef);

  protected readonly faIconLibrary: FaIconLibrary = inject(FaIconLibrary);

  @ContentChild(TemplateRef) private _content?: TemplateRef<unknown>;

  protected hasProjectedContent: WritableSignal<boolean> = signal(false);

  public name: InputSignal<string | undefined> = input();

  public collapsed: InputSignal<boolean> = input(false);

  public icon: InputSignal<IconName | undefined> = input<IconName>();

  public additionalIcon: InputSignal<IconName | undefined> = input<IconName>();

  constructor () {
    this.faIconLibrary.addIcons(...SIDEBAR_ICONS);
  }

  public ngAfterContentInit (): void {
    this.hasProjectedContent.set(Boolean(this._content));
  }
}
